import { render, staticRenderFns } from "./lowEffortDetected.vue?vue&type=template&id=2ebfce5a&"
import script from "./lowEffortDetected.vue?vue&type=script&lang=js&"
export * from "./lowEffortDetected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports